var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { singleton } from '../decorators';
import { generateUuid } from '../utils';
import { MasterDataSDK } from './MasterData.sdk';
import { StaffProfileService } from './services/StaffProfile.service';
import { AttendanceRecordService } from './services/AttendanceRecord.service';
let NekoStaffSdk = class NekoStaffSdk extends MasterDataSDK {
    api;
    id;
    staffProfile;
    attendanceRecord;
    constructor(api, id = generateUuid()) {
        super(api, id);
        this.api = api;
        this.id = id;
        this.staffProfile = new StaffProfileService(this.api, this.getAuthHeader);
        this.attendanceRecord = new AttendanceRecordService(this.api, this.getAuthHeader);
    }
};
NekoStaffSdk = __decorate([
    singleton,
    __metadata("design:paramtypes", [String, Object])
], NekoStaffSdk);
export { NekoStaffSdk };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTmVrb1N0YWZmLnNkay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZGtzL05la29TdGFmZi5zZGsudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUMxQyxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBQ3hDLE9BQU8sRUFBRSxhQUFhLEVBQUUsTUFBTSxrQkFBa0IsQ0FBQztBQUNqRCxPQUFPLEVBQUUsbUJBQW1CLEVBQUUsTUFBTSxpQ0FBaUMsQ0FBQztBQUN0RSxPQUFPLEVBQUUsdUJBQXVCLEVBQUUsTUFBTSxxQ0FBcUMsQ0FBQztBQUV2RSxJQUFNLFlBQVksR0FBbEIsTUFBTSxZQUFhLFNBQVEsYUFBYTtJQUl2QjtJQUF1QjtJQUg3QyxZQUFZLENBQXNCO0lBQ2xDLGdCQUFnQixDQUEwQjtJQUUxQyxZQUFzQixHQUFXLEVBQVksS0FBSyxZQUFZLEVBQUU7UUFDOUQsS0FBSyxDQUFDLEdBQUcsRUFBRSxFQUFFLENBQUMsQ0FBQztRQURLLFFBQUcsR0FBSCxHQUFHLENBQVE7UUFBWSxPQUFFLEdBQUYsRUFBRSxDQUFpQjtRQUU5RCxJQUFJLENBQUMsWUFBWSxHQUFHLElBQUksbUJBQW1CLENBQUMsSUFBSSxDQUFDLEdBQUcsRUFBRSxJQUFJLENBQUMsYUFBYSxDQUFDLENBQUM7UUFDMUUsSUFBSSxDQUFDLGdCQUFnQixHQUFHLElBQUksdUJBQXVCLENBQ2pELElBQUksQ0FBQyxHQUFHLEVBQ1IsSUFBSSxDQUFDLGFBQWEsQ0FDbkIsQ0FBQztJQUNKLENBQUM7Q0FDRixDQUFBO0FBWlksWUFBWTtJQUR4QixTQUFTOztHQUNHLFlBQVksQ0FZeEIifQ==